import { Stack, Typography, Card, Icon, Skeleton } from 'investira.react.components';
import { formats } from 'investira.sdk';

const Highlights = props => {
  const { isLoading } = props;
  const { total_financeiro, total_ativos } = props.data;

  return (
    <Stack gap={1.5}>
      <Stack
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(2, 1fr)',
            xl: 'repeat(2, 1fr)'
          },
          gap: 1.5
        }}>
        {isLoading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              height={100}
              sx={{ borderRadius: 2, flex: 1 }}
            />
          ))
        ) : (
          <>
            <Card
              sx={{
                flexGrow: 1,
                display: 'flex',
                minHeight: 0
              }}>
              <Stack px={2} py={2} gap={2}>
                <Stack direction="row" gap={2}>
                  <Icon iconName="money_missing" color="secondaryLightness" size={21} />
                  <Stack direction="column" gap={1} sx={{ marginTop: '-3px' }}>
                    <Typography variant="subtitle1">Total Financeiro</Typography>
                    <Typography variant="h6" fontWeight="bold">
                      {formats.formatNumber(total_financeiro || 0, 2, true, true)}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
            <Card
              sx={{
                flexGrow: 1,
                display: 'flex',
                minHeight: 0
              }}>
              <Stack px={2} py={2} gap={2}>
                <Stack direction="row" gap={2}>
                  <Icon iconName="box_3d" color="secondaryLightness" size={21} />
                  <Stack direction="column" gap={1} sx={{ marginTop: '-3px' }}>
                    <Typography variant="subtitle1">Quantidade de Ativos</Typography>
                    <Typography variant="h6" fontWeight="bold">
                      {total_ativos}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </>
        )}
      </Stack>
    </Stack>
  );
};

export default Highlights;
